import { useState } from "react";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Usersearch } from "../../components/userSearch/UserSearch";
import CopyToClipboardWrapper from "../../components/copyToClipboardWrapper/CopyToClipboardWrapper";

const apiEnpoint: any = process.env.REACT_APP_API_BASE_URL;

function UserSearchPage() {
  const accessToken: any = localStorage?.getItem("accessToken");
  const navigate = useNavigate();

  const redirctToGroupedAccount = (row: any) => {
    navigate(`/grouped-account/${row?.UserId}`);
  };

  const handleRowClick = (params: any) => {
    navigate(`/user/${params.row.UserId}`);
  };

  const formatDate = (dateString: string) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  };

  const searchUserColumns: GridColDef[] = [
    {
      field: "FirstName",
      headerName: "FirstName",
      headerClassName: "customTableHeader",
      cellClassName: "customTableCell",
      width: 130,
      renderCell: (params: GridRenderCellParams<any, any>) => (
        <div
          style={{
            display: "flex",
            alignItems: "left"
          }}
        >
          <div
            style={{
              verticalAlign: "middle",
              display: "flex",
              alignItems: "center"
            }}
          >
            {params?.row?.FirstName ? params?.row?.FirstName : "-"}
          </div>
          {params?.row?.UserId && (
            <div onClick={(e) => e?.stopPropagation()}>
              <CopyToClipboardWrapper
                text={params?.row?.UserId}
                cell="UserId"
              />
            </div>
          )}
        </div>
      )
    },
    {
      field: "Surname",
      headerName: "Surname",
      headerClassName: "customTableHeader",
      cellClassName: "customTableCell",
      width: 130,
      renderCell: (params: GridRenderCellParams<any, any>) => (
        <div>{params?.row?.Surname ? params?.row?.Surname : "-"}</div>
      )
    },
    {
      field: "IsActive",
      headerName: "Status",
      headerClassName: "customTableHeader",
      cellClassName: "customTableCell",
      width: 120,
      renderCell: (params: GridRenderCellParams<any, any>) => {
        const isActive = params?.row?.IsActive;
        // Handle undefined/null case
        if (isActive === undefined || isActive === null) {
          return <div style={{ color: "#666" }}>Unknown</div>;
        }
        return (
          <Button
            variant="contained"
            size="small"
            sx={{
              backgroundColor: isActive ? "success.main" : "error.main",
              color: "white",
              textTransform: "none",
              minWidth: "100px",
              "&:hover": {
                backgroundColor: isActive ? "success.dark" : "error.dark"
              }
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {isActive ? "Active" : "Inactive"}
          </Button>
        );
      }
    },
    {
      field: "QRCode",
      headerName: "QR Code",
      headerClassName: "customTableHeader",
      cellClassName: "customTableCell",
      width: 200,
      renderCell: (params: GridRenderCellParams<any, any>) => (
        <div>{params?.row?.QRCode || "-"}</div>
      )
    },
    {
      field: "UserType",
      headerName: "User Type",
      headerClassName: "customTableHeader",
      cellClassName: "customTableCell",
      width: 120,
      renderCell: (params: GridRenderCellParams<any, any>) => {
        const qrCode = params?.row?.QRCode;
        let userType = "-";

        if (qrCode && qrCode.trim() !== "") {
          if (qrCode.startsWith("07P")) {
            userType = "App";
          } else {
            userType = "Card";
          }
        }
        return <div>{userType}</div>;
      }
    },
    {
      field: "Email",
      headerName: "Email",
      headerClassName: "customTableHeader",
      cellClassName: "customTableCell",
      width: 350,
      renderCell: (params: GridRenderCellParams<any, any>) => (
        <div
          style={{
            display: "flex",
            alignItems: "left"
          }}
        >
          <div
            style={{
              verticalAlign: "middle",
              display: "flex",
              alignItems: "center"
            }}
          >
            {params?.row?.Email ? params?.row?.Email : "-"}
          </div>
          {params?.row?.Email && (
            <div onClick={(e) => e?.stopPropagation()}>
              <CopyToClipboardWrapper text={params?.row?.Email} cell="Email" />
            </div>
          )}
        </div>
      )
    },
    {
      field: "Mobile",
      headerName: "Mobile",
      headerClassName: "customTableHeader",
      cellClassName: "customTableCell",
      width: 130,
      renderCell: (params: GridRenderCellParams<any, any>) => (
        <div>{params?.row?.Mobile ? params?.row?.Mobile : "-"}</div>
      )
    },
    {
      field: "PatronId",
      headerName: "PatronId",
      headerClassName: "customTableHeader",
      cellClassName: "customTableCell",
      width: 170,
      renderCell: (params: GridRenderCellParams<any, any>) => (
        <div
          style={{
            display: "flex",
            alignItems: "left"
          }}
        >
          <div
            style={{
              verticalAlign: "middle",
              display: "flex",
              alignItems: "center"
            }}
          >
            {params?.row?.PatronId ? params?.row?.PatronId : "-"}
          </div>
          {params?.row?.PatronId && (
            <div onClick={(e) => e?.stopPropagation()}>
              <CopyToClipboardWrapper
                text={params?.row?.PatronId}
                cell="PatronId"
              />
            </div>
          )}
        </div>
      )
    },
    {
      field: "PatronMasterId",
      headerName: "PatronMasterId",
      headerClassName: "customTableHeader",
      cellClassName: "customTableCell",
      width: 200,
      renderCell: (params: GridRenderCellParams<any, any>) => (
        <div
          style={{
            display: "flex",
            alignItems: "left"
          }}
        >
          <div
            style={{
              verticalAlign: "middle",
              display: "flex",
              alignItems: "center"
            }}
          >
            {params?.row?.PatronMasterId ? params?.row?.PatronMasterId : "-"}
          </div>
          {params?.row?.PatronMasterId && (
            <div onClick={(e) => e?.stopPropagation()}>
              <CopyToClipboardWrapper
                text={params?.row?.PatronMasterId}
                cell="PatronMasterId"
              />
            </div>
          )}
        </div>
      )
    },
    {
      field: "MatchedOn",
      headerName: "MatchedOn",
      headerClassName: "customTableHeader",
      cellClassName: "customTableCell",
      width: 130,
      renderCell: (params: GridRenderCellParams<any, any>) => (
        <div>{params?.row?.MatchedOn ? params?.row?.MatchedOn : "-"}</div>
      )
    }
  ];

  return (
    <>
      <Usersearch
        searchUserColumns={searchUserColumns}
        accessToken={accessToken}
        apiBaseUrl={apiEnpoint}
        handleRowClick={handleRowClick}
      />
    </>
  );
}

export default UserSearchPage;
